<ion-input
  [class.required]="required"
  [type]="type"
  [placeholder]="placeholder"
  [label]="label"
  [labelPlacement]="labelPlacement"
  [helperText]="helperText"
  [required]="required"
  [inputmode]="inputmode"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [min]="min"
  [max]="max"
  [step]="step"
  [pattern]="pattern"
  [name]="name"
  [debounce]="debounce"
  [readonly]="readonly"
  [disabled]="disabled"
  [clearInput]="clearInput"
  [clearOnEdit]="clearOnEdit"
  [autocapitalize]="autocapitalize"
  [autocorrect]="autocorrect"
  [autocomplete]="autocomplete"
  [enterkeyhint]="enterkeyhint"
  [id]="inputId"
  [value]="value"
  (ionInput)="handleInput($event)"
  (ionChange)="ionChange.emit($event)"
  (ionBlur)="handleBlur($event)"
  (ionFocus)="ionFocus.emit($event)"
  (ionClear)="ionClear.emit($event)"
>
  <ng-content></ng-content>
</ion-input>
